import React, { useEffect, useState } from "react";
import { Button, Icon, Label } from "semantic-ui-react";
import { InstitutionalDocument } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CustomTable } from "../../../Shared";
import { buildStorageUrl, formatFileSize } from "../../../../utils";

const institutionalDocumentController = new InstitutionalDocument();

export function ListInstitutionalDocuments(props) {
  const { reload, year } = props;
  const { accessToken } = useAuth();

  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response =
          await institutionalDocumentController.getInstitutionalDocuments(
            accessToken,
            year
          );
        setDocuments(response);
      } catch (error) {
        console.error(error);
        setDocuments([]);
      }
      setLoading(false);
    })();
  }, [accessToken, reload, year]);

  const tableConfig = {
    headers: ["Título", "Año", "Descripción", "Archivo"],
    fields: [
      { field: "title", dataType: "text" },
      {
        field: "year",
        component: "custom",
        align: "center",
        render: (row) => <Label color="blue">{row.year}</Label>,
      },
      { field: "description", dataType: "text" },
      {
        field: "filePath",
        component: "custom",
        align: "center",
        render: (row) => (
          <Button
            as="a"
            href={buildStorageUrl(row.filePath)}
            target="_blank"
            rel="noopener noreferrer"
            icon
            labelPosition="left"
            color="green"
            size="small"
          >
            <Icon name="eye" />
            Ver PDF
            {row.fileSize ? (
              <span style={{ opacity: 0.85, marginLeft: 6 }}>
                ({formatFileSize(row.fileSize)})
              </span>
            ) : null}
          </Button>
        ),
      },
    ],
    columnWidths: ["35%", "10%", "35%", "20%"],
  };

  return (
    <div className="student-institutional-documents__list">
      <CustomTable
        tableConfig={tableConfig}
        data={documents}
        bordered
        hover
        striped
        loading={loading}
      />
    </div>
  );
}
